import { render, staticRenderFns } from "./corporate-taxpayers-unactivated-icon.vue?vue&type=template&id=4703b5ee"
import script from "./corporate-taxpayers-unactivated-icon.vue?vue&type=script&lang=js"
export * from "./corporate-taxpayers-unactivated-icon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports